import React from 'react';
import { Formik as OriginalFormik } from 'formik';

import {
  Formik as RealFormik,
  FormikConfig,
  FormikValues,
  FormikProps,
} from 'formik';
import { FormSchemaContext } from './FormSchemaContext';

export function Formik<V extends FormikValues = FormikValues>(
  props: FormikConfig<V>,
): JSX.Element {
  const { validationSchema, children } = props;
  return (
    <RealFormik {...props}>
      {(formikBag: FormikProps<V>) => (
        <FormSchemaContext.Provider value={validationSchema as never}>
          {typeof children === 'function'
            ? (children as (bag: FormikProps<V>) => React.ReactNode)(formikBag)
            : (children as React.ReactNode)}
        </FormSchemaContext.Provider>
      )}
    </RealFormik>
  );
}

export {
  Form,
  Field,
  FieldArray,
  ErrorMessage,
  FormikProvider,
  FormikConsumer,
  FormikContext,
  useFormik,
  useField,
  useFormikContext,
  connect,
  getIn,
  setIn,
  setNestedObjectValues,
  isEmptyArray,
  isEmptyChildren,
  isFunction,
  isObject,
  isInteger,
  isString,
  isNaN,
  isPromise,
  isInputEvent,
  validateYupSchema,
  yupToFormErrors,
  withFormik,
} from 'formik';

export type {
  FormikConfig,
  FormikValues,
  FormikProps,
  FormikHelpers,
  FormikErrors,
  FormikHandlers,
  FormikState,
  FormikTouched,
  FormikSharedConfig,
  FormikComputedProps,
  FormikRegistration,
  FormikContextType,
  FormikBag,
  FieldArrayRenderProps,
  FieldProps,
  FieldHookConfig,
  FieldInputProps,
  FieldMetaProps,
  FieldHelperProps,
  FieldConfig,
  FieldAttributes,
  FieldValidator,
  ArrayHelpers,
  WithFormikConfig,
  InjectedFormikProps,
} from 'formik';

export { FormSchemaProvider, useFieldRequired, FormSchemaContext } from './FormSchemaContext';



export * from 'formik';

const visuallyHiddenStyle: React.CSSProperties = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
};

const RequiredFieldsHint = (): JSX.Element => (
    <span style={visuallyHiddenStyle}>* indicates required fields</span>
);

const FormikWithHint = ((props: any) => (
    <>
        <RequiredFieldsHint />
        <OriginalFormik {...props} />
    </>
)) as typeof OriginalFormik;
